function ptmInit(){
  /* ---------- helpers ---------- */
  const ROOT=document.getElementById('ptm-root'); if(!ROOT) return;
  const $ = id => document.getElementById('ptm-'+id);
  let CFG={}; try{ CFG=JSON.parse($('config').textContent); }catch(e){}
  const esc=s=>String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const toast = msg => { const t=$('toast'); t.textContent=msg; t.classList.add('show'); clearTimeout(t._h); t._h=setTimeout(()=>t.classList.remove('show'),2200); };
  const share = async (text) => {
    const url = location.href.split('#')[0];
    try{ if(navigator.share){ await navigator.share({title:'The Parent Test', text, url}); return; } }catch(e){ return; }
    try{ await navigator.clipboard.writeText(text+' '+url); toast('Link copied. Paste it anywhere.'); }catch(e){ toast('Copy the page link to share.'); }
  };

  /* ---------- PARENT TEST GAME ---------- */
  // Oct 1 revisions: no scoring. Every card reveals its fact, and everyone gets the same result screen.
  const CARDS = (CFG.cards||[]).filter(c=>c.claim);
  if(!CARDS.length){ /* no cards configured */ }
  let idx=0, busy=false;
  const deck=$('deck'), prog=$('progress'), choices=$('choices');
  prog.innerHTML = CARDS.map(()=>'<span></span>').join('');

  function renderProgress(){ [...prog.children].forEach((s,i)=>{ s.className = i<idx?'done':(i===idx?'now':''); }); }
  function cardHTML(i,cls){ const c=CARDS[i]; return `<div class="card ${cls}" data-i="${i}">
      <div class="stamp no">Not for my mom or dad</div><div class="stamp yes">I'd choose this</div>
      <div class="num">${i+1} of ${CARDS.length}</div>
      <div class="claim">${esc(c.claim)}</div>
      <div class="hint"><span>← Not for my mom or dad</span><span>I'd choose this →</span></div></div>`; }
  function renderDeck(){
    renderProgress();
    let h='';
    if(idx+2<CARDS.length) h+=cardHTML(idx+2,'back2');
    if(idx+1<CARDS.length) h+=cardHTML(idx+1,'back');
    h+=cardHTML(idx,'front');
    deck.innerHTML=h; busy=false; choices.style.visibility='visible';
    bindDrag(deck.querySelector('.front'));
  }
  function bindDrag(card){
    let sx=0, dx=0, down=false;
    const yes=card.querySelector('.stamp.yes'), no=card.querySelector('.stamp.no');
    card.addEventListener('pointerdown',e=>{ if(busy) return; down=true; sx=e.clientX; dx=0; card.classList.add('dragging'); card.setPointerCapture(e.pointerId); });
    card.addEventListener('pointermove',e=>{ if(!down) return; dx=e.clientX-sx; card.style.transform=`translateX(${dx}px) rotate(${dx/18}deg)`; yes.style.opacity=Math.max(0,Math.min(1,dx/90)); no.style.opacity=Math.max(0,Math.min(1,-dx/90)); });
    const end=()=>{ if(!down) return; down=false; card.classList.remove('dragging');
      if(Math.abs(dx)>90) decide(dx>0); else { card.style.transform=''; yes.style.opacity=0; no.style.opacity=0; } };
    card.addEventListener('pointerup',end); card.addEventListener('pointercancel',end);
  }
  function decide(choseYes){
    if(busy) return; busy=true;
    const card=deck.querySelector('.front'), c=CARDS[idx];
    card.style.transform=`translateX(${choseYes?560:-560}px) rotate(${choseYes?24:-24}deg)`; card.style.opacity='0';
    choices.style.visibility='hidden';
    setTimeout(()=>{
      const r=document.createElement('div'); r.className='reveal';
      r.innerHTML=`<span class="verdict">${choseYes?"You'd choose it":"Not for your mom or dad"}</span>
        <div class="fact">${esc(c.fact)}<small>${esc(c.more)}</small></div>
        <div><button class="btn sm" id="ptm-nextBtn">${idx+1<CARDS.length?'Next card':'See my result'}</button></div>`;
      deck.appendChild(r); card.remove();
      $('nextBtn').focus({preventScroll:true});
      $('nextBtn').onclick=()=>{ idx++; if(idx<CARDS.length) renderDeck(); else showResult(); };
    },300);
  }
  function confetti(){ const cols=['#E8731C','#DCE8F5','#1F3F6E','#F3E6D8','#FFFFFF'];
    for(let i=0;i<70;i++){ const c=document.createElement('i'); c.className='confetti'; c.style.left=Math.random()*100+'vw'; c.style.background=cols[i%cols.length]; c.style.animationDuration=(1.8+Math.random()*1.8)+'s'; c.style.animationDelay=(Math.random()*.5)+'s'; ROOT.appendChild(c); setTimeout(()=>c.remove(),4200); } }
  function showResult(){
    prog.querySelectorAll('span').forEach(s=>s.className='done'); choices.style.display='none';
    deck.style.height='auto';
    deck.innerHTML=`<div class="result"><div class="result-icon" aria-hidden="true">💙</div>
      <h3>You took the Parent Test. Now put HeelCheck to it.</h3>
      <p>Thanks for caring like family. Here's 50% off a HeelCheck sample kit so you can try it on your own floor.</p>
      <div class="row"><a class="btn" href="${esc(CFG.kitUrl||'#ptm-kit')}">Claim my 50% off</a></div>
      <div class="row"><button class="link-btn" id="ptm-shareRes">Share the Parent Test with your team</button></div></div>`;
    confetti();
    $('shareRes').onclick=()=>share("Take the 60-second Parent Test: would you choose it for your own mom or dad?");
  }
  $('btnYes').onclick=()=>decide(true); $('btnNo').onclick=()=>decide(false);
  document.addEventListener('keydown',e=>{ const tEl=$('test'); if(!tEl) return; const r=tEl.getBoundingClientRect(); if(r.top>innerHeight||r.bottom<0||busy||idx>=CARDS.length) return;
    if(e.key==='ArrowRight') decide(true); if(e.key==='ArrowLeft') decide(false); });
  if(CARDS.length) renderDeck();

  /* ---------- NOMINATION (prototype: shows thank-you, sends nothing) ---------- */
  const nf=$('nomForm');
  if(nf){ nf.addEventListener('submit',e=>{
    const req=['nName','nFac','nWhy','yName','yEmail'].map($).filter(Boolean);
    const miss=req.find(el=>!el.value.trim()||(el.type==='email'&&!el.checkValidity()));
    if(miss){ e.preventDefault(); miss.focus(); toast('Please fill in every field.'); }
  }); }
  const sn=$('shareNom'); if(sn) sn.onclick=()=>share("Know a nurse who cares like family? Nominate them for Skil-Care's Care Like Family award.");

  /* ---------- CALCULATOR (break-even, price-agnostic) ---------- */
  const HC_START = Math.max(1, +CFG.hcRep || 2); // starting value, set in the theme editor
  const sRepEl=$('sRep'); if(sRepEl && !sRepEl.value) sRepEl.value=HC_START;
  const hcRep=()=>Math.max(1, +(sRepEl ? sRepEl.value : HC_START) || HC_START);
  const fmt=n=>'$'+Math.round(n).toLocaleString('en-US');
  const fmt2=n=>'$'+(Math.round(n*100)/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  $('sRepOut').textContent=hcRep();
  // load shared numbers from the link (?beds=60&cp=12&cr=6&q=30)
  const qs=new URLSearchParams(location.search);
  if(qs.has('beds')||qs.has('cp')){
    const set=(k,id)=>{ if(qs.has(k)&&!isNaN(+qs.get(k))) $(id).value=qs.get(k); };
    set('beds','beds'); set('cp','cPrice'); set('cr','cRep'); if(sRepEl) set('sr','sRep');
    if(qs.get('q')){ $('qPrice').value=qs.get('q'); $('qBox').hidden=false; $('qToggle').setAttribute('aria-expanded','true'); $('qToggle').textContent='− Hide my HeelCheck price'; }
    $('sharedNote').hidden=false;
  }
  $('qToggle').onclick=()=>{ const open=$('qBox').hidden; $('qBox').hidden=!open; $('qToggle').setAttribute('aria-expanded',String(open));
    $('qToggle').textContent= open?'− Hide my HeelCheck price':'+ I have a HeelCheck price from my distributor'; if(!open){ $('qPrice').value=''; } calc(); if(open) $('qPrice').focus(); };
  function calc(){
    const beds=+$('beds').value, cp=Math.max(0,+$('cPrice').value||0), cr=+$('cRep').value, q=Math.max(0,+$('qPrice').value||0);
    const HC_REP=hcRep();
    $('bedsOut').textContent=beds; $('cRepOut').textContent=cr; $('sRepOut').textContent=HC_REP;
    const be = cp*cr/HC_REP, mult = cr/HC_REP;
    if(cp<=0){ $('beLine').textContent='Enter what you pay today'; $('beSub').textContent='Your break-even price will appear here.'; }
    else if(mult>1){ $('beLine').innerHTML=`HeelCheck saves you money at any price under <b>${fmt2(be)}</b> each.`;
      $('beSub').textContent=`At ${HC_REP} replacements a year instead of ${cr}, HeelCheck can cost up to ${mult%1?mult.toFixed(1):mult}× what you pay now and still come out ahead.`; }
    else if(mult===1){ $('beLine').innerHTML=`At these numbers, HeelCheck breaks even at <b>${fmt2(be)}</b> each.`; $('beSub').textContent='Same replacement rate, so the comparison comes down to comfort and care.'; }
    else { $('beLine').innerHTML=`HeelCheck breaks even at <b>${fmt2(be)}</b> each.`; $('beSub').textContent="At these numbers your current boot lasts longer, so ask your distributor for a quote on your real volume."; }
    const cu=beds*cr, su=beds*HC_REP;
    $('cUnits').textContent=cu.toLocaleString(); $('sUnits').textContent=su.toLocaleString();
    const draw=(el,n)=>{ el.innerHTML=Array.from({length:n},(_,i)=>`<i style="animation-delay:${i*40}ms"></i>`).join(''); };
    draw($('cBoots'),cr); draw($('sBoots'),HC_REP);
    const showQ = !$('qBox').hidden && q>0 && cp>0;
    $('quoteOut').hidden=!showQ;
    if(showQ){ const ct=cu*cp, st=su*q, d=ct-st; $('cTotal').textContent=fmt(ct); $('sTotal').textContent=fmt(st);
      $('calcVerdict').textContent = d>0 ? `That's ${fmt(d)} a year back in your budget, and ${(cu-su).toLocaleString()} fewer boots in the trash.` :
        (d<0 ? `At this quote HeelCheck costs ${fmt(-d)} more a year. Your break-even is ${fmt2(be)}, so it's worth a conversation with your distributor.` : 'Same cost. Then it comes down to which one you\'d choose for your own mom or dad.'); }
  }
  ['beds','cPrice','cRep','sRep','qPrice'].forEach(id=>{ const el=$(id); if(el) el.addEventListener('input',calc); }); calc();
  $('shareCalc').onclick=async()=>{
    const p=new URLSearchParams({beds:$('beds').value, cp:$('cPrice').value, cr:$('cRep').value, sr:String(hcRep())});
    if(!$('qBox').hidden && +$('qPrice').value>0) p.set('q',$('qPrice').value);
    const url=location.href.split('?')[0].split('#')[0]+'?'+p.toString()+'#ptm-cost';
    const text='Here are your heel protection numbers. See how HeelCheck compares:';
    try{ if(navigator.share){ await navigator.share({title:'The real cost of cheap', text, url}); return; } }catch(e){ return; }
    try{ await navigator.clipboard.writeText(url); toast('Link with these numbers copied.'); }catch(e){ toast('Could not copy the link on this device.'); }
  };


  /* ---------- CATALOG: page-turn preview + flipbook pop-up ---------- */
  (function(){
    // Realistic page-turn preview using StPageFlip (assets/ptm-page-flip.js)
    const flipEl=$('flip'), link=$('book'), pages=(CFG.catalogPages||[]).filter(Boolean);
    const reduce=window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(flipEl && link && pages.length>=3 && !reduce && window.St && St.PageFlip){
      let pf=null, visible=false, timer=null;
      const start=()=>{
        if(pf) return;
        pf=new St.PageFlip(flipEl,{ width:306, height:396, size:'stretch', minWidth:150, maxWidth:600, minHeight:194, maxHeight:776,
          showCover:true, usePortrait:false, drawShadow:true, maxShadowOpacity:0.55, flippingTime:1300,
          useMouseEvents:false, mobileScrollSupport:false, autoSize:true, showPageCorners:false });
        pf.loadFromImages(pages);
        flipEl.classList.add('ready');
      };
      const tick=()=>{
        if(!pf||!visible||document.hidden) return;
        const land = pf.getOrientation()==='landscape';
        const i=pf.getCurrentPageIndex(), n=pf.getPageCount();
        if(i >= n-(land?2:1)){ link.classList.add('fading'); setTimeout(()=>{ pf.turnToPage(0); link.classList.remove('fading'); },500); }
        else pf.flipNext('top');
      };
      const obs=new IntersectionObserver(es=>{ visible=es[0].isIntersecting; clearInterval(timer);
        if(visible){ start(); setTimeout(tick,900); timer=setInterval(tick,3400); } },{threshold:.35});
      obs.observe(link);
    }
    const modal=$('catModal'), frame=$('catFrame'), url=CFG.catalogUrl;
    if(!modal||!url) return;
    let lastFocus=null;
    const open=()=>{ lastFocus=document.activeElement; if(!frame.getAttribute('src')) frame.setAttribute('src',url);
      modal.hidden=false; document.documentElement.style.overflow='hidden'; $('catClose').focus(); };
    const close=()=>{ modal.hidden=true; document.documentElement.style.overflow=''; if(lastFocus) lastFocus.focus({preventScroll:true}); };
    ROOT.querySelectorAll('[data-ptm-catalog]').forEach(a=>a.addEventListener('click',e=>{
      if(CFG.catalogMode==='newtab'||e.metaKey||e.ctrlKey||e.shiftKey) return; e.preventDefault(); open(); }));
    $('catClose').onclick=close;
    modal.addEventListener('click',e=>{ if(e.target===modal) close(); });
    document.addEventListener('keydown',e=>{ if(e.key==='Escape'&&!modal.hidden) close(); });
  })();

  /* ---------- TIMELINE REVEAL ---------- */
  const io=new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }),{threshold:.2});
  ROOT.querySelectorAll('.mile').forEach(m=>io.observe(m));

  /* ---------- COUNTDOWN ---------- */
  const target=new Date((CFG.countdown||'2026-11-19')+'T00:00:00');
  function tick(){ let ms=Math.max(0,target-new Date()); const d=Math.floor(ms/864e5); ms-=d*864e5; const h=Math.floor(ms/36e5); ms-=h*36e5; const m=Math.floor(ms/6e4);
    $('cdD').textContent=d; $('cdH').textContent=h; $('cdM').textContent=m; }
  tick(); setInterval(tick,30000);

  /* ---------- TIPS (clinical wording for JT review) ---------- */
  const TIPS=(CFG.tips||[]).filter(x=>x.t);
  let demo=false;
  function renderTips(){ const now=new Date();
    $('tipRow').innerHTML=TIPS.map((x,i)=>{ const open=demo||new Date(x.d+'T00:00:00')<=now; const day=new Date(x.d+'T00:00:00').toLocaleDateString('en-US',{month:'short',day:'numeric'});
      return open ? `<div class="tip open"><div><div class="wk">Tip ${i+1}</div><h4>${esc(x.t)}</h4><p>${esc(x.p)}</p></div><button class="share" data-i="${i}">Share this tip</button></div>`
                  : `<div class="tip locked"><div><div class="wk">Tip ${i+1}</div><h4>Unlocks ${day}</h4></div><div class="lock">🔒 Check back soon</div></div>`; }).join('');
    $('tipRow').querySelectorAll('.share').forEach(b=>b.onclick=()=>share('HeelCheck tip: '+TIPS[+b.dataset.i].t)); }
  renderTips();
  if($('demoBtn')) $('demoBtn').onclick=()=>{ demo=!demo; $('demoBtn').textContent=demo?'Show real unlock schedule':'Preview all tips (demo only)'; renderTips(); };
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',ptmInit);}else{ptmInit();}
document.addEventListener('shopify:section:load',function(e){ if(e.target && e.target.querySelector('#ptm-root')) ptmInit(); });
